import AINetwork from '@/components/AINetwork';
import ServiceCard from '@/components/ServiceCard';
import CTABand from '@/components/CTABand';
import { SERVICES } from '@/lib/content';

export default function ServicesPage() {
  return (
    <div>
      <section className="relative pt-32 pb-16 lg:pt-44 lg:pb-20 overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-30" aria-hidden />
        <AINetwork density={26} />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="text-xs uppercase tracking-[0.22em] text-cyan-300/80 mb-5">Services</div>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[1.02] tracking-tighter max-w-4xl text-balance">
            A complete <span className="gradient-text">growth operating</span> system.
          </h1>
          <p className="mt-7 max-w-2xl text-lg text-white/70 leading-relaxed">
            Eight integrated practices — designed to be deployed independently or as a single,
            end-to-end mandate.
          </p>
        </div>
      </section>

      <section className="relative py-16 lg:py-24 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {SERVICES.map((s) => (
              <ServiceCard key={s.slug} service={s} variant="detailed" />
            ))}
          </div>
        </div>
      </section>

      {/* Engagement Models */}
      <section className="relative py-24 lg:py-28 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="max-w-2xl mb-12">
            <div className="text-xs uppercase tracking-[0.22em] text-cyan-300/80 mb-4">How we engage</div>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight">
              Three ways to work with us.
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            {[
              { t: 'Sprint Diagnostic', d: '2–4 week growth & AI readiness audit. KPI tree, opportunity map, and 12-month roadmap.', cta: 'Most popular' },
              { t: 'Strategic Retainer', d: 'Embedded growth leadership across performance, automation, analytics and lifecycle.', cta: 'Outcome-bound' },
              { t: 'Transformation Mandate', d: 'Multi-quarter digital transformation — operating model, stack, capability and AI.', cta: 'Enterprise' },
            ].map((x, i) => (
              <div key={i} className="relative rounded-2xl border border-white/10 bg-[#0B1221]/60 p-8 hover:border-cyan-400/30 transition-all">
                <div className="font-mono-display text-xs text-cyan-300 mb-5">{x.cta}</div>
                <h3 className="font-heading text-2xl font-medium mb-3">{x.t}</h3>
                <p className="text-sm text-white/65 leading-relaxed">{x.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABand title="Pick a starting point. We'll design the rest." ctaLabel="Discuss Your Growth Goals" />
    </div>
  );
}
